<div class="contenedor-spinner">


    <div class="spinner">
        <img src="../../../../assets/img/logo_withoutBG.png" alt="">
    </div>

</div>